// libs
import React from 'react';

// components
import { Typography } from '@lyearn/ui';
import { ResourceTypeEnum } from '@/types/schema';
// utils
import getHumanDuration from '@/utils/time/getHumanDurationRounded';

// context
import { useLearningContent } from '../context';
// types
import { DurationProps } from '../types';

export function formatSnakeCase(str?: string): string {
  const words = str
    ?.split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
  return (words || [])?.join(' ');
}

function Duration({
  variant = 'body-short-03',
  color = 'text-text-secondary',
  className,
}: DurationProps) {
  const { content } = useLearningContent();

  const isKnowledgeAssetType = content.type === ResourceTypeEnum.KnowledgeAsset;
  const knowledgeAssetSubType = content?.knowledgeAssetSubType;

  if (isKnowledgeAssetType && knowledgeAssetSubType) {
    return (
      <Typography className={className} color={color} variant={variant}>
        {formatSnakeCase(knowledgeAssetSubType)}
      </Typography>
    );
  }

  if (!content.duration || content.duration === -1) {
    return null;
  }

  return (
    <Typography className={className} color={color} variant={variant}>
      {typeof content.duration === 'string' ? content.duration : getHumanDuration(content.duration)}
    </Typography>
  );
}

export default React.memo(Duration);
